import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_DomesticViolenceAssessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_DomesticViolenceAssessment' className='file-pdf-document'>

            <div className='file-template'>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Family Name:</span>
                            <input type='text' id="txtFamilyName" name="txtFamilyName" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Children's Name & Date of Birth:</span>
                            <input type='text' id="txtChildrenNameDOB" name="txtChildrenNameDOB" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Case Number:</span>
                            <input type='text' id="txtCaseNumber" name="txtCaseNumber" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>County:</span>
                            <input type='text' id="txtCounty" name="txtCounty" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Case Manager:</span>
                            <input type='text' id="txtCaseManager" name="txtCaseManager" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Person Completing Form:</span>
                            <input type='text' id="txtPersonCompletingForm" name="txtPersonCompletingForm" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date Assessment Completed:</span>
                            <input   id="txtDateAssessmentCompleted" name="txtDateAssessmentCompleted" type='date' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type='text' id="txtCountyDepartment" name="txtCountyDepartment" className='add-only' />
                    County Department of Family and Children Services requested a domestic violence assessment for
                    <input type='text' id="txtAssesmentFor" name="txtAssesmentFor" className='add-only' />. This clinician met with
                    <input type='text' id="txtMetWith" name="txtMetWith" className='add-only' />
                    and completed the interview on
                    <input   id="txtInterviewCompleted" name="txtInterviewCompleted" type='date' />.
                </p>
                <p className='w-750'>
                    <input type='text' id="txtChildName" name="txtChildName" className='add-only' /> is a
                    <input type='text' id="txtAge" name="txtAge" className='add-only' /> years old
                    <input type='text' id="txtRaceOrEthnicity" name="txtRaceOrEthnicity" className='add-only' />
                    (race/ethnicity)
                    <select id="ddlSex" name="ddlSex" className='add-only'>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                    </select>
                    who reports having
                    <select id="ddlbiologicaladopted" name="ddlbiologicaladopted" className='add-only'>
                        <option value="biological">biological</option>
                        <option value="adopted">adopted</option>
                    </select>
                    children. At the time of this assessment he/she was living with
                    <input type='text' id="txtLivingWith" name="txtLivingWith" className='add-only' />
                    (dob <input   id="txtParentDOB" name="txtParentDOB" type='date' />).
                    <input type='text' id="txtParents" name="txtParents" className='add-only' /> the
                    <select id="ddlParents" name="ddlParents" className='add-only'>
                        <option value="mother">mother</option>
                        <option value="father">father</option>
                    </select>
                    of his/her <input type='text' id="txtGender" name="txtGender" className='add-only' /> children:
                    <input type='text' id="txtChildernName" name="txtChildernName" className='add-only' />
                    (dob <input   id="txtChildrenDOB" name="txtChildrenDOB" type='date' />). The
                    child is/children are current residing with <input type='text' id="txtChildResiding" name="txtChildResiding" className='add-only' />
                    who resides in <input type='text' id="txtCity" name="txtCity" className='add-only' />, Georgia.
                </p>
                <h4>Purpose of Assessment</h4>
                <p className='w-750'>
                    DFCS requested a domestic violence assessment due to allegations of domestic violence between
                    <input type='text' id="txtViolance" name="txtViolance" className='add-only' /> and
                    <input type='text' id="txtViolanceWith" name="txtViolanceWith" className='add-only' />, and allegations
                    as well that the children may have witnessed domestic violence. The current allegations against the
                    <select id="ddlGuardian" name="ddlGuardian" className='add-only' >
                        <option value="parent(s)">parent(s)</option>
                        <option value="guardian(s)">guardian(s)</option>
                    </select>
                    at this time is
                    <input type='text' id="txtCurrentAllegationsTime" name="txtCurrentAllegationsTime" className='add-only' />.
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Pre-Interview Contact With:</span>
                            <span className='small'>(If completed.)</span>
                            <input type='text' id="txtContactWith" name="txtContactWith" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>At time of this assessment, assessor met with:</span>
                            <input type='text' id="txtAssessorMetWith" name="txtAssessorMetWith" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Dress and Demeanor:</span>
                            <input type='text' id="txtDress" name="txtDress" className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <th className='w-150'>Demographic Information</th>
                        <th className='w-300'>Parent/Guardian Name</th>
                        <th className='w-300'>Spouse/Partner, Name</th>
                    </tr>
                    <tr>
                        <td>Race</td>
                        <td><input type='text' id="txtRaceParentName" name="txtRaceParentName" className='add-only' /></td>
                        <td><input type='text' id="txtRaceSpouseName" name="txtRaceSpouseName" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td>Date of Birth</td>
                        <td><input   id="txtDOBParent" name="txtDOBParent" type='date' /></td>
                        <td><input  id="txtDOBSpouse" name="txtDOBSpouse" type='date' /></td>
                    </tr>
                    <tr>
                        <td>Marital Status</td>
                        <td><input type='text' id="txtMaritalStatusParents" name="txtMaritalStatusParents" className='add-only' /></td>
                        <td><input type='text' id="txtMaritalStatusSpouse" name="txtMaritalStatusSpouse" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td>Education</td>
                        <td><input type='text' id="txtEducationParents" name="txtEducationParents" className='add-only' /></td>
                        <td><input type='text' id="txtEducationSpouse" name="txtEducationSpouse" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td>Job Training</td>
                        <td><input type='text' id="txtJobTrainingPrents" name="txtJobTrainingPrents" className='add-only' /></td>
                        <td><input type='text' id="txtJobTrainingSpouse" name="txtJobTrainingSpouse" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td>Employment</td>
                        <td><input type='text' id="txtEmploymentParents" name="txtEmploymentParents" className='add-only' /></td>
                        <td><input type='text' id="txtEmploymentSpouse" name="txtEmploymentSpouse" className='add-only' /></td>
                    </tr>
                </table>
                <h4>Children</h4>
                <table>
                    <tr>
                        <th className='w-150'>Name</th>
                        <th className='w-150'>Age</th>
                        <th className='w-150'>DOB</th>
                        <th className='w-300'>Biological/Adoptive Parents</th>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id="txtChildrenName1" name="txtChildrenName1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txtChildrenAge1" name="txtChildrenAge1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input  id="txtChildrenDOB1" name="txtChildrenDOB1" type='date' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txtChildrenBiologicalParent1" name="txtChildrenBiologicalParent1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txtChildrenAdaptiveParent1" name="txtChildrenAdaptiveParent1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td><input type='text' id="txtChildrenName2" name="txtChildrenName2" className='add-only' /></td>
                        <td><input type='text' id="txtChildrenAge2" name="txtChildrenAge2" className='add-only' /></td>
                        <td><input   id="txtChildrenDOB2" name="txtChildrenDOB2" type='date' /></td>
                        <td><input type='text' id="txtChildrenBiologicalParent2" name="txtChildrenBiologicalParent2" className='add-only' /></td>
                        <td><input type='text' id="txtChildrenAdaptiveParent2" name="txtChildrenAdaptiveParent2" className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Assessment Interview:</span>
                    <textarea id="txtAssesmentInterview" name="txtAssesmentInterview" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Interview with Spouse/Significant Other:</span>
                    <textarea id="txtInterviewSpouseOther" name="txtInterviewSpouseOther" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Family History – Parents and Siblings:</span>
                    <textarea id="txtFamilyHistory" name="txtFamilyHistory" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Relationship History:</span>
                    <textarea id="txtRelationshipHistory" name="txtRelationshipHistory" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Substance Use/Abuse/Addiction:</span>
                    <textarea id="txtAbuseAddiction" name="txtAbuseAddiction" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Medical/Psychological/Psychiatric:</span>
                    <textarea id="txtMedical" name="txtMedical" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Legal History:</span>
                    <textarea id="txtLegalHistory" name="txtLegalHistory" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Job History:</span>
                    <textarea id="txtJobHistory" name="txtJobHistory" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Summary:</span>
                    <textarea id="txtSummary" name="txtSummary" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    Due to the numerous and consistent concerns of domestic violence in the relationship
                    between <input type='text' id="txtRelationship" name="txtRelationship" className='add-only' />, New Heights Behavioral
                    Consultants makes the following recommendations:
                </p>
                <ol>
                    <li><input type='text' id="txtRecommendation1" name="txtRecommendation1" className='add-only' /></li>
                    <li><input type='text' id="txtRecommendation2" name="txtRecommendation2" className='add-only' /></li>
                    <li><input type='text' id="txtRecommendation3" name="txtRecommendation3" className='add-only' /></li>
                    <li><input type='text' id="txtRecommendation4" name="txtRecommendation4" className='add-only' /></li>
                </ol>
                <table>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Name and Credentials of Assessor</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                </table>
                <p className='w-750'>Under the Supervision of:</p>
                <table>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small  w-600'>
                            Robert L. Clemons, M.S., LPC<br />Clinical Supervisor, GA License LPC #004041<br />New Heights Behavioral Consultants, Inc.
                        </td>
                        <td className='small w-150'>Date</td>
                    </tr>
                </table>
            </div>
        </form>

    )
} 
